import { Button } from '@hivebrite/design-system/Button';

const ButtonCancel = ({ handleCancelModal }) => (
  <Button variant="secondary" onClick={handleCancelModal}>
    {__('Cancel')}
  </Button>
);

export default ButtonCancel;
